import * as $ from 'jquery';
declare var require: any;
let validate = require('jquery-validation');

export const  init = () => {
    // Log-in and remind-password
    $('#log-in, #remind-password, #contact').validate({
        rules: {
            name: {
                required: true
            },
            message: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 5
            }
        },
        messages: {
            name: "Proszę podać imię i nazwisko",
            message: "Proszę uzupełnić pole wiadomość",
            email: {
                required: "Proszę podać adres e-mail",
                email: "Twój e-mail musi być w formacie name@domain.com"
            },
            password: {
                required: "Proszę podać hasło",
                minlength: "Min. liczba znaków 5"
            },
        },
        submitHandler: function(form) {
            form.submit();
        }
    });
    // Sign-in
    $('#sign-in').validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 5
            },
            password2: {
                required: true,
                equalTo: "#password",
                minlength : 5,
                password2: true,
            },
            check: {
                required: true
            }
        },
        messages: {
            email: {
                required: "Proszę podać adres e-mail",
                email: "Twój e-mail musi być w formacie name@domain.com"
            },
            password: {
                required: "Proszę podać hasło",
                minlength: "Min. liczba znaków 5"
            },
            password2: {
                required: "Proszę powtórzyć hasło",
                equalTo: "Proszę podać takie samo hasło"
            },
            check: {
                required: "Proszę zaznaczyć zgodę"
            }
        },
        submitHandler: function(form) {
            form.submit();
        }
    });
};